<template>
    <vs-row vs-justify="center">
     <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
       <vs-card>
         <div class="d-md-flex align-items-center pb-2">
         <h3 class="card-title mb-0">Kas Keluar</h3>
         <div class="ml-auto">
           <vs-button @click="backpage" color="danger" type="filled" class="mt-4 mt-md-0" icon="highlight_off" v-focus>
            Batal
           </vs-button>
         </div>
         </div>
         <vs-alert v-if="errors.length" class="mb-3 mt-2"  color="danger">
             <b>Terdapat Kesalahan..</b>
             <ul class="common-list">
             <li v-for="error in errors" :key="error">{{ error }}</li>
             </ul>
         </vs-alert>
           <div>
           <vs-row>
           <vs-col vs-lg="3" vs-xs="12" vs-sm="4">
             <div class="vs-component vs-con-input-label vs-input w-100 mt-4 vs-input-primary">
             <label class="vs-input--label">Tanggal</label>
             <div class="vs-con-input">
             <date-picker
             v-model="formdata.trans_tgl"
             format="DD-MM-YYYY"
             value-type="format"
             placeholder="Pilih Tgl" input-class="vs-input--input"
             :disabled-date="disabledBeforeYear">
             </date-picker>
             </div>
             </div>
           </vs-col>
           </vs-row>

           <!-- Pilih Mode Pembayaran -->
           <vs-row class="mt-3">
             <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
               <label class="vs-input--label d-block mb-2">Mode Pembayaran</label>
               <div class="d-flex align-items-center">
                 <vs-radio v-model="payMode" vs-value="manual" class="mr-4">Manual (Rincian Perkiraan)</vs-radio>
                 <vs-radio v-model="payMode" vs-value="ap">Account Payable</vs-radio>
               </div>
             </vs-col>
           </vs-row>

           <!-- Mode: Account Payable (belum lunas) -->
           <vs-row v-if="payMode === 'ap'" class="mt-2">
             <vs-col vs-lg="7" vs-xs="12" vs-sm="8">
               <vs-select class="w-100 mt-4" autocomplete label="Pilih Account Payable (belum lunas)" v-model="selectedApId">
                 <vs-select-item
                   v-for="(ap, i) in apOptions"
                   :key="i"
                   :value="ap.id"
                   :text="ap.display"
                 />
               </vs-select>
             </vs-col>
             <vs-col vs-lg="3" vs-xs="12" vs-sm="4" v-if="selectedApId">
               <vs-input label="Sisa Hutang" class="w-100 mt-4" :value="selectedApSisaFormatted" disabled />
             </vs-col>
             <vs-col vs-lg="2" vs-xs="12" vs-sm="12" v-if="selectedApId">
               <div class="mt-5 pt-1">
                 <small class="text-muted">{{ selectedApInfo }}</small>
               </div>
             </vs-col>
           </vs-row>

           <!-- Rincian Pembayaran AP -->
           <vs-row v-if="payMode === 'ap' && selectedApId" class="mt-4">
             <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
               <h5 class="mb-2">Rincian Pembayaran & Potongan AP</h5>
               <div v-for="(row, idx) in apDetails" :key="idx" class="mb-2 p-2 border-bottom">
                 <vs-row style="align-items: center;">
                   <vs-col vs-lg="3" vs-xs="12" vs-sm="4">
                     <vs-input label="Nominal" class="w-100 mt-2" v-model="row.nominal" v-currency="options" />
                   </vs-col>
                   <vs-col vs-lg="3" vs-xs="12" vs-sm="4">
                     <vs-select label="Tipe" class="w-100 mt-2" v-model="row.tipe">
                       <vs-select-item value="Pembayaran" text="Pembayaran" />
                       <vs-select-item value="PPH 23" text="PPH 23" />
                       <vs-select-item value="Biaya Bank" text="Biaya Bank" />
                     </vs-select>
                   </vs-col>
                   <vs-col vs-lg="4" vs-xs="12" vs-sm="3" v-if="row.tipe === 'PPH 23'">
                     <vs-input label="No Bukti Potongan" class="w-100 mt-2" v-model="row.no_bukti" />
                   </vs-col>
                   <vs-col vs-lg="2" vs-xs="12" vs-sm="1">
                     <div class="mt-4 pt-2">
                       <vs-button color="danger" icon="remove_circle" type="flat" @click="removeApDetailRow(idx)" v-if="apDetails.length > 1"></vs-button>
                     </div>
                   </vs-col>
                 </vs-row>
               </div>
               <div class="btn-alignment mt-3 d-flex align-items-center">
                 <vs-button color="primary" icon="add" type="gradient" @click="addApDetailRow">Tambah Rincian</vs-button>
                 <span class="ml-4 font-weight-bold" style="font-size: 1.1rem; line-height: 2.2rem;">Total Rincian: {{ sumApDetailsFormatted }}</span>
               </div>
             </vs-col>
           </vs-row>

           <!-- Mode: Manual (Rincian Perkiraan) -->
        <vs-row v-if="payMode === 'manual'" class="mt-2">
          <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
            <h5 class="mb-2">Rincian Perkiraan</h5>
            <div v-for="(row, idx) in perkRows" :key="idx" class="mb-2 p-2 border-bottom">
              <vs-row>
                <vs-col vs-lg="3" vs-xs="12" vs-sm="6">
                  <vs-select class="w-100 mt-4" autocomplete label="Kode Perkiraan" v-model="row.kode_perk" @change="onPerkChange(row)">
                    <vs-select-item
                      v-for="(opt, i) in perkOptions"
                      :key="i"
                      :value="opt.kode_perk"
                      :text="opt.kode_perk + ' - ' + (opt.nama_perk || opt.nama)"
                    />
                  </vs-select>
                </vs-col>
                <vs-col vs-lg="3" vs-xs="12" vs-sm="6">
                   <vs-input label="Nama Perkiraan" class="w-100 mt-4" v-model="row.nama_perk" readonly />
                </vs-col>
                <vs-col vs-lg="2" vs-xs="12" vs-sm="4">
                  <vs-input label="Nilai" class="w-100 mt-4" v-model="row.nilai" v-currency="options"/>
                </vs-col>
                <vs-col vs-lg="3" vs-xs="12" vs-sm="4">
                  <vs-input label="Keterangan" class="w-100 mt-4" v-model="row.keterangan"/>
                </vs-col>
                <vs-col vs-lg="1" vs-xs="12" vs-sm="2">
                  <div class="mt-5">
                    <vs-button color="danger" icon="remove" type="flat" @click="removeRow(idx)" v-if="perkRows.length > 1"></vs-button>
                  </div>
                </vs-col>
              </vs-row>
            </div>
            <vs-button color="primary" icon="add" type="gradient" @click="addRow">Tambah Baris</vs-button>
          </vs-col>
        </vs-row>
       </div>
         <br/>
         <div class="btn-alignment mt-4">
           <vs-button color="success" type="filled" @click.stop.prevent="checkForm">Simpan</vs-button>
           <vs-button color="dark" @click="backpage" type="filled">Batal</vs-button>
         </div>
       </vs-card>
     </vs-col>
    </vs-row>
</template>

<script>
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import { CurrencyDirective, parseCurrency } from 'vue-currency-input'

  export default {
    components: {
       DatePicker
    },
    directives: {
        currency: CurrencyDirective
    },
    data: function () {
      return {
        locale: 'us',
        currency: null,
        // mode: 'manual' | 'ap'
        payMode: 'manual',
        // data account payable
        apOptions: [],
        selectedApId: null,
        apDetails: [],
        formdata: {
            trans_jumlah: 0,
            trans_tgl: '',
            keterangan: '',
            isEdit: false,
            prevReferensi: this.$route.params.ref,
        },
        // dynamic rows for perkiraan details
        perkOptions: [],
        perkRows: [
            { kode_perk: '', nama_perk: '', nilai: 0, keterangan: '' }
        ],
        errors: [],
        inputUrl: '/api/voucher'
      }
    },
    methods: {
        backpage: function() {
            this.$router.go(-1);
        },
        disabledBeforeYear(date) {
            return date.getFullYear() < window.$cookies.get('THN') || date.getFullYear() > window.$cookies.get('THN');
        },
        numberValue(value) {
            const val = value ? value : 0;
            return parseCurrency(val.toString(), this.options)
        },
        onPerkChange(row) {
            const found = this.perkOptions.find(p => p.kode_perk === row.kode_perk);
            if (found) row.nama_perk = found.nama_perk || found.nama || '';
        },
        getAllData: function() {
            if(this.$route.params.ref != null) {
                this.formdata.isEdit = true
                this.$http.get(this.inputUrl + "/" + this.$route.params.ref).then(response => {
                    const d = response.data;
                    this.formdata.keterangan = d.keterangan;
                    if(d.tanggal) {
                        let parts = d.tanggal.split("-");
                        this.formdata.trans_tgl = `${parts[2]}-${parts[1]}-${parts[0]}`;
                    }
                    if (Number(d.ap_id) > 0) {
                        this.payMode = 'ap';
                        this.selectedApId = d.ap_id;
                        this.$nextTick(() => {
                            this.apDetails = d.ap_details || [];
                        });
                    } else {
                        this.payMode = 'manual';
                        this.selectedApId = null;
                        this.apDetails = [];
                        if (d.details && d.details.length > 0) {
                            this.perkRows = d.details.map(rd => ({
                                kode_perk: rd.kode_perk,
                                nama_perk: rd.nama_perk,
                                nilai: Number(rd.nilai) || 0,
                                keterangan: rd.keterangan || ''
                            }));
                        }
                    }
                }).catch(error => {
                    console.log(error)
                    this.$vs.notify({title:'Error',text:'Gagal inisiasi data, silahkan coba lagi...',color:'danger'})
                })
            }
            this.formdata.opr = this.$store.getters.getUserName
        },
        fetchPerkOptions: function() {
            this.$http.get('/api/perklist').then(resp => {
                this.perkOptions = resp.data || []
            }).catch(() => {
                this.perkOptions = []
            })
        },

        fetchAccountPayable: function() {
            let url = '/api/accountpayable-unpaid';
            if (this.$route.params.ref != null) {
                url += '?voucher_id=' + this.$route.params.ref;
            }
            this.$http.get(url).then(resp => {
                const arr = Array.isArray(resp.data) ? resp.data : []
                this.apOptions = arr.map(ap => ({
                    id: ap.id,
                    no_ap: ap.no_ap,
                    nama_supplier: ap.nama_supplier || '-',
                    no_referensi: ap.no_referensi || '',
                    nomor_fp: ap.nomor_fp || '',
                    total_nilai: Number(ap.total_nilai || 0),
                    sisa_hutang: Number(ap.sisa_hutang || 0),
                    jenis_hutang: ap.jenis_hutang || 'lokal',
                    display: `${ap.no_ap} | ${ap.nama_supplier || '-'} | Ref: ${ap.no_referensi || '-'} | FP: ${ap.nomor_fp || '-'} | Sisa: ${new Intl.NumberFormat('id-ID',{style:'decimal',maximumFractionDigits:0}).format(Number(ap.sisa_hutang||0))}`
                }))
            }).catch(() => {
                this.apOptions = []
            })
        },
        addRow: function() {
            this.perkRows.push({ kode_perk: '', nama_perk: '', nilai: 0, keterangan: '' })
        },
        removeRow: function(index) {
            this.perkRows.splice(index, 1)
        },
        addApDetailRow() {
            this.apDetails.push({ nominal: 0, tipe: 'Pembayaran', no_bukti: '' })
        },
        removeApDetailRow(index) {
            this.apDetails.splice(index, 1)
        },
        normalizedPerkRows: function() {
            return this.perkRows
                .filter(r => r && r.kode_perk)
                .map(r => ({
                    kode_perk: r.kode_perk,
                    nama_perk: r.nama_perk,
                    nilai: this.numberValue(r.nilai),
                    keterangan: r.keterangan || ''
                }))
        },
        checkForm: function() {
            this.errors = []
            if(!this.formdata.trans_tgl) this.errors.push('Tanggal belum terisi...')

            let payload = { ...this.formdata }

            if(this.payMode === 'ap') {
                if(!this.selectedApId) this.errors.push('Account Payable belum dipilih...')
                const sel = this.apOptions.find(a => a.id == this.selectedApId)
                if (sel) {
                    const totalDetail = this.sumApDetails
                    if (totalDetail <= 0) {
                        this.errors.push('Total rincian pembayaran harus lebih besar dari 0.')
                    }
                    if (totalDetail > sel.sisa_hutang) {
                        this.errors.push(`Total rincian pembayaran (${this.sumApDetailsFormatted}) melebihi sisa hutang (${this.selectedApSisaFormatted}).`)
                    }
                    this.apDetails.forEach((row, i) => {
                        if (row.tipe === 'PPH 23' && (!row.no_bukti || row.no_bukti.trim() === '')) {
                            this.errors.push(`Baris ${i + 1}: No Bukti Potongan wajib diisi untuk PPH 23.`)
                        }
                    })

                    payload.ap_id = this.selectedApId
                    payload.trans_jumlah = totalDetail
                    payload.ap_details = this.apDetails.map(row => ({
                        nominal: this.numberValue(row.nominal),
                        tipe: row.tipe,
                        no_bukti: row.no_bukti || ''
                    }))
                    payload.mode = 'ap'
                }

            } else {
                const rows = this.normalizedPerkRows()
                if(rows.length === 0) this.errors.push('Rincian perkiraan minimal 1 baris...')
                rows.forEach((r, i) => {
                    if(!r.kode_perk) this.errors.push(`Baris ${i+1}: Kode perkiraan belum dipilih...`)
                    if(!r.nilai || r.nilai <= 0) this.errors.push(`Baris ${i+1}: Nilai belum terisi...`)
                })
                payload.perk_rows = rows
                const total = rows.reduce((acc, r) => acc + Number(r.nilai || 0), 0)
                payload.trans_jumlah = total
                payload.mode = 'manual'
            }

            if(this.errors.length > 0) {
                this.notify()
                return
            }

            this.$vs.loading({ type: 'radius' })
            this.$http.post(this.inputUrl, { formdata: payload }).then(() => {
                this.handleSuccess()
            }).catch((error) => {
                if (error && error.response && error.response.data && error.response.data.errors) {
                    const keys = Object.keys(error.response.data.errors)
                    for(const key of keys) this.errors.push(error.response.data.errors[key][0])
                } else {
                    this.errors.push('Terjadi error di server..')
                }
                this.notify()
                this.$vs.loading.close()
            })
        },
        handleSuccess: function() {
            this.$vs.loading.close()
            this.$vs.notify({title:'Success',text:'Data berhasil disimpan..',color:'success'})
            this.$router.push({name: 'voucherlist'});
        },
        notify: function() {
            this.$vs.notify({
                title:'Gagal Menyimpan Data',
                text:'Click untuk melihat',
                color:'danger',
                fixed:false,
                icon: 'warning',
                click:() => {
                    window.scrollTo(0,0);
                },
            })
        }
    },
    computed: {
        options() {
            return {
                locale: this.locale,
                currency: this.currency
            }
        },

        // Account Payable computed
        selectedAp() {
            return this.apOptions.find(a => a.id == this.selectedApId) || null
        },
        selectedApSisa() {
            return this.selectedAp ? this.selectedAp.sisa_hutang : 0
        },
        selectedApSisaFormatted() {
            return new Intl.NumberFormat('id-ID',{style:'decimal',maximumFractionDigits:0}).format(this.selectedApSisa)
        },
        selectedApInfo() {
            if (!this.selectedAp) return ''
            return `Jenis: ${this.selectedAp.jenis_hutang} | Total: ${new Intl.NumberFormat('id-ID',{style:'decimal',maximumFractionDigits:0}).format(this.selectedAp.total_nilai)}`
        },
        sumApDetails() {
            return this.apDetails.reduce((acc, row) => acc + Number(this.numberValue(row.nominal || 0)), 0)
        },
        sumApDetailsFormatted() {
            return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(this.sumApDetails)
        }
    },
    watch: {
        selectedApId(newVal) {
            if (newVal) {
                const sel = this.apOptions.find(a => a.id == newVal)
                if (sel) {
                    this.apDetails = [
                        { nominal: sel.sisa_hutang, tipe: 'Pembayaran', no_bukti: '' }
                    ]
                } else {
                    this.apDetails = []
                }
            } else {
                this.apDetails = []
            }
        }
    },
    mounted: function() {
        this.getAllData();
        this.fetchPerkOptions();

        this.fetchAccountPayable();
    }
  }
</script>

<style src='@/assets/styles/jqwidgets/jqx.base.css'></style>
<style lang="stylus">
.cetak
  height: 90vh
</style>